import React from "react";

/**
 * React Context um das Verhalten für einen  Back-Button
 * und einem Forwar-Button zu definieren, wenn man sich auf einem
 * "sm" Viewport befindet.
 */
export const MobileNavigationContext = React.createContext<
	{ onBackButtonClicked?(): void; onForwardButtonClicked?(): void } | undefined
>(undefined);
